import { theme } from "../../utils/theme";

export const styles = {
  item: {
    alignItems: "center",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: 8, md: 10 },
    height: { md: 420 },
    mb: { xs: 8, md: 16 },
    mt: { xs: 8, md: 16 },
    px: { xs: 0, md: 24 },
    overflow: "hidden",
  },
  itemContentBody: {
    color: theme.palette.grays[700],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.body,
    },
    fontWeight: 300,
    letterSpacing: 1.2,
    lineHeight: 1.5,
  },
  itemContentListBullet: {
    backgroundColor: theme.palette.grays[900],
    borderRadius: 50,
    minHeight: 6,
    ml: { xs: 2, md: 2 },
    mr: { xs: 4, md: 4 },
    mt: { xs: 1.4, md: 2.4 },
    minWidth: 6,
  },
  itemContentListButton: {
    minWidth: 160,
  },
  itemContentContainer: {
    gap: 6,
    height: "100%",
    justifyContent: { xs: "start", sm: "center" },
    px: { xs: 0, md: 12 },
    py: { xs: 4, md: 8 },
    width: { xs: "100%", md: "50%" },
  },
  itemContentHeader: {
    color: theme.palette.grays[700],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.h5,
    },
    fontWeight: 600,
    letterSpacing: 1.2,
    lineHeight: 1.1,
    textTransform: "capitalize",
  },
  itemContentList: {
    color: theme.palette.grays[700],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.h5,
    },
    lineHeight: 1.5,
  },
  itemContentListContainer: {
    alignItems: "flex-start",
    display: "flex",
  },
  itemContentSubheader: {
    color: theme.palette.secondary.main,
    fontSize: {
      xs: theme.typography.h2,
      md: theme.typography.h2,
    },
    fontWeight: 700,
    letterSpacing: 1.2,
    lineHeight: 1.1,
  },
};
